/**
 * Injection key linking BaseTab panes to their parent BaseTabs container.
 *
 * Provided value shape:
 * {
 *   activeTabId: ComputedRef<string|null>,
 *   register: (tab: { id: string, title: string }) => void,
 *   unregister: (tab: { id: string, title: string }) => void,
 * }
 */
export const baseTabsKey = Symbol('baseTabs');
